import React, { useEffect, useMemo, useState } from 'react';
import './InAppNotice.css';

const getHint = (message) => {
  const text = String(message || '').toLowerCase();

  if (text.includes('connecte') || text.includes('connexion')) {
    return 'Connectez-vous depuis la page "Vous" puis recommencez.';
  }
  if (text.includes('email')) {
    return 'Verifiez le format de votre email puis ressayez.';
  }
  if (text.includes('mot de passe') || text.includes('password')) {
    return 'Utilisez un mot de passe valide puis recommencez.';
  }
  if (text.includes('paiement') || text.includes('orange')) {
    return 'Verifiez vos informations de paiement (numero, PIN, devise) puis validez de nouveau.';
  }
  if (text.includes('champ') || text.includes('remplir') || text.includes('manqu')) {
    return 'Completez tous les champs obligatoires (*) puis continuez.';
  }
  if (text.includes('reseau') || text.includes('network') || text.includes('serveur')) {
    return 'Verifiez votre connexion internet puis reessayez dans quelques secondes.';
  }

  return 'Verifiez les informations saisies puis reessayez.';
};

export default function InAppNotice() {
  const [notice, setNotice] = useState(null);

  const hint = useMemo(() => getHint(notice?.message), [notice?.message]);

  useEffect(() => {
    const previousAlert = window.alert;

    const showNotice = (rawMessage) => {
      setNotice({
        id: Date.now(),
        message: String(rawMessage || 'Une erreur est survenue.')
      });
    };

    window.alert = (message) => {
      showNotice(message);
    };

    const onAppAlert = (event) => {
      showNotice(event?.detail?.message || event?.detail || 'Une erreur est survenue.');
    };

    window.addEventListener('booktube:alert', onAppAlert);

    return () => {
      window.alert = previousAlert;
      window.removeEventListener('booktube:alert', onAppAlert);
    };
  }, []);

  if (!notice) return null;

  return (
    <div className="inapp-notice-overlay" role="alertdialog" aria-live="assertive">
      <div className="inapp-notice-card">
        <h4>BookTube</h4>
        <p className="inapp-notice-message">{notice.message}</p>
        <p className="inapp-notice-hint">{hint}</p>
        <button type="button" onClick={() => setNotice(null)}>
          Compris
        </button>
      </div>
    </div>
  );
}

